module.exports = __webpack_public_path__ + "static/media/football.a45eb548.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/teachers/noticeboard/football.svg
// module id = 565
// module chunks = 0